import styled from 'styled-components'

const Container = styled.div`
  padding: 16px;
`

const Header = styled.div`
  display: flex;
  font-size: 20px;
  margin-bottom: 40px;
`

const ButtonsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: end;
  gap: 12px;
`

export { Header, Container, ButtonsContainer }
